export default __webpack_public_path__ + "images/080eb938ae2e935b81b99218b9cadac1.png";